import React, { useRef, useState } from 'react'
import { CanvasKNFrame } from './CanvasKNFrame'
import { CanvasToolbar } from './CanvasToolbar'
import { useFullscreen } from '../../hooks/useFullscreen'
import type { CascadeViewMode } from './strategyMapHelpers'
import './StrategyCanvas.css'

export const StrategyCanvas: React.FC = () => {
  const rootRef = useRef<HTMLDivElement>(null)
  const { isFullscreen, toggle, supported } = useFullscreen(rootRef)
  const [viewMode, setViewMode] = useState<CascadeViewMode>('filtered')
  const fallbackActive = !supported && isFullscreen
  const className = `strategy-canvas-root${fallbackActive ? ' is-fullscreen-fallback' : ''}`
  return (
    <section ref={rootRef} className={className} aria-label="Strategy Canvas">
      <CanvasToolbar
        isFullscreen={isFullscreen}
        onToggleFullscreen={toggle}
        viewMode={viewMode}
        onChangeViewMode={setViewMode}
      />
      <CanvasKNFrame viewMode={viewMode} />
    </section>
  )
}

export default StrategyCanvas
